// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"ClientStatusChangePopup_pageStyle__Ud6cm","dialogCard":"ClientStatusChangePopup_dialogCard__K3-R5"};